import { availabilityGridQueryKeys as e } from "../calendar/useCalendarQueryKeys.mjs";
import { listingQueryKeys as t } from "./useListingSearchQuery.mjs";
import { useMutation as n, useQueryClient as r } from "@maat/store-hooks";
import { listingsApi as i } from "@maat/api-main";
//#region src/listings/useUnblockDatesMutation.ts
var a = () => {
	let a = r();
	return n({
		mutationFn: ({ listingId: e, ...t }) => i.unblockDates(e, t),
		onSuccess: (n, { listingId: r }) => {
			a.invalidateQueries({ queryKey: t.calendar(r) }), a.invalidateQueries({ queryKey: e.all() });
		}
	});
};
//#endregion
export { a as useUnblockDatesMutation };
